import { coreApi } from '@cp/shared/api/core';
import { ClientCatalogItemViewModel } from '@common/model/client/catalog/item/clientCatalogItemViewModel';
import { ApiRoutePathParams } from '@common/api/routePathParams';
import { ApiRouteBody } from '@common/api/routeBody';
import { ApiRoute } from '@common/api/route';
import { generateApiUrl } from '@common/api/configure';
import { apiRouteMethodDict } from '@common/api/routeMethod';
import { VacancyApiTags, vacancyApiTagTypes } from './tags';

export const vacancyApi = coreApi
  .enhanceEndpoints({
    addTagTypes: vacancyApiTagTypes,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getVacancyListForCurrectClient: builder.query<ClientCatalogItemViewModel[], void>({
        query: () => {
          return {
            url: generateApiUrl(ApiRoute.ClientVacanciesGet),
          };
        },
        providesTags: [{ type: VacancyApiTags.CurrentClientVacanciesList }],
      }),

      getVacancyForCurrentClientById: builder.query<ClientCatalogItemViewModel, ApiRoutePathParams[ApiRoute.ClientVacanciesGetOne]>({
        query: (params) => {
          return {
            url: generateApiUrl(ApiRoute.ClientVacanciesGetOne, params),
          };
        },
        providesTags: (_result, _error, { id }) => [{ type: VacancyApiTags.CurrentClientVacancy, id }],
      }),

      createVacancyForCurrentClient: builder.mutation<void, ApiRouteBody[ApiRoute.ClientVacanciesCreate]>({
        query: (body) => ({
          url: generateApiUrl(ApiRoute.ClientVacanciesCreate),
          method: apiRouteMethodDict[ApiRoute.ClientVacanciesCreate],
          body,
        }),
        invalidatesTags: [{ type: VacancyApiTags.CurrentClientVacanciesList }],
      }),

      updateVacancyForCurrentClientById: builder.mutation<
        void,
        { params: ApiRoutePathParams[ApiRoute.ClientVacanciesUpdate]; body: ApiRouteBody[ApiRoute.ClientVacanciesUpdate] }
      >({
        query: ({ params, body }) => ({
          url: generateApiUrl(ApiRoute.ClientVacanciesUpdate, params),
          method: apiRouteMethodDict[ApiRoute.ClientVacanciesUpdate],
          body,
        }),
        invalidatesTags: (_result, _error, { params: { id } }) => [
          { type: VacancyApiTags.CurrentClientVacanciesList },
          { type: VacancyApiTags.CurrentClientVacancy, id },
        ],
      }),

      deleteVacancyForCurrentClientById: builder.mutation<void, { params: ApiRoutePathParams[ApiRoute.ClientVacanciesDelete] }>({
        query: ({ params }) => ({
          url: generateApiUrl(ApiRoute.ClientVacanciesDelete, params),
          method: apiRouteMethodDict[ApiRoute.ClientVacanciesDelete],
        }),
        invalidatesTags: [{ type: VacancyApiTags.CurrentClientVacanciesList }],
      }),
    }),
  });
